/* eslint-disable prettier/prettier */
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import { escapeHTML } from "bpmn-js-properties-panel/lib/Utils";
import $ from "jquery";
import React from "react";
import { createRoot } from "react-dom/client";

import ModelerModalDocumentsForSignature from "./modeler-modal-documents-for-signature";
import { getUnitPropertie } from "../../../../../containers/smart/camunda/forms/functions";
import { language } from "../../../../../language";
import {
  getSelectBox,
  getUniqueTaskFields,
} from "../../../../../util/camundaPropertiesPanelUtils";

window.jQuery = $;
window.$ = $;

function DocumentsForSignatureModal(
  elementdom,
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  selectBox,
  saveDocuments,
  fields,
  docsToSign,
) {
  const root = createRoot(elementdom);
  root.render(
    <ModelerModalDocumentsForSignature
      businessObject={businessObject}
      element={element}
      extensionElements={extensionElements}
      bpmnFactory={bpmnFactory}
      selectBox={selectBox}
      saveDocuments={saveDocuments}
      fields={fields}
      docsToSign={docsToSign}
    />,
  );
}
export default function (
  element,
  bpmnFactory,
  options,
  translate,
  modeling,
  saveDocuments,
) {
  const id = options.id;
  const boxId = options.boxId;
  const label = language.selectDocuments;
  const businessObject = getBusinessObject(element);

  return {
    id,
    html:
      '<button id="cam-extensionElements-' +
      escapeHTML(id) +
      '"' +
      'data-action="openDocumentsForSignature" ' +
      'name="selectedExtensionElement" ' +
      'class="btn info"' +
      'style="margin-left: auto;margin-right: auto;width: 100%;"' +
      '" >' +
      label +
      "</button>",
    openDocumentsForSignature(element, node) {
      const fields = getUniqueTaskFields(businessObject);

      const extensionElements = businessObject.get("extensionElements");

      let docsToSign = [];

      if (extensionElements) {
        const extensionProperties = extensionElements.values.find(
          function (elem) {
            if (elem.$type === "camunda:Properties") {
              return true;
            }
            return false;
          },
        );

        if (extensionProperties && extensionProperties.values) {
          for (
            let idxProperty = 0;
            idxProperty < extensionProperties.values.length;
            idxProperty++
          ) {
            const camundaProperty = extensionProperties.values[idxProperty];
            if (camundaProperty.name === "assinaturaConfig") {
              let docConfig = {};
              try {
                docConfig = JSON.parse(camundaProperty.value);
              } catch (err) {
                console.error(err);
              }
              docsToSign = getUnitPropertie(docConfig, "documentsToSign") || [];
            }
          }
        }
      }

      const modelerModalDocumentsForSignature = document.createElement(
        "modelerModalDocumentsForSignature",
      );

      DocumentsForSignatureModal(
        modelerModalDocumentsForSignature,
        businessObject,
        element,
        businessObject.get("extensionElements"),
        bpmnFactory,
        getSelectBox(node, boxId),
        saveDocuments,
        fields,
        docsToSign,
      );
    },
  };
}
